<template>
  <v-row class="btn-end">
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            class="mr-5 mt-5 mb-5"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            small
            @click="addBtn = true"
        >
          Add tags to group
        </v-btn>

        <v-btn
            class="mr-11 mt-5 mb-5"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            small
            @click="removeBtn = true"
        >
          Remove tags from group
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit users tags</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col v-if="addBtn">
                <v-select
                    item-text="label"
                    :items="tags"
                    label="Add tag"
                    v-model="addTags"
                    multiple
                    return-object
                    :disabled="deleteTags.length > 0"
                />
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.label }} </span>
                  <span
                      v-if="index === 1"
                      class="grey--text text-caption"
                  > (+ {{ addTags.length - 1 }} others)
                  </span>
                </template>
              </v-col>
              <v-col v-if="removeBtn">
                <v-select
                    item-text="label"
                    :items="tags"
                    label="Remove tag"
                    v-model="deleteTags"
                    multiple
                    return-object
                    :disabled="addTags.length > 0"
                />
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.label }} </span>
                  <span
                      v-if="index === 1"
                      class="grey--text text-caption"
                  > (+ {{ deleteTags.length - 1 }} others)
                  </span>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="saveTagEdit">Save
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="resetTagDropdowns">Reset
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "UserPermissionsTagTableDialog",
  data() {
    return {
      dialog: false,
      addTags: [],
      deleteTags: [],
      editTag: null,
      addBtn: false,
      removeBtn: false,
    }
  },
  computed: {
    ...mapState('userPermissions', ['tags', 'allUserTableList'])
  },
  methods: {
    ...mapActions('userPermissions', ['editUsersTags', 'fetchAllUsers']),
    async saveTagEdit() {
      let tagsLabel = null
      let tagsId = null
      let matchingUsers = []
      if (this.deleteTags.length > 0) {
        this.editTag = 'remove'
        tagsLabel = this.deleteTags.map(tag => tag.label)
        tagsId = this.deleteTags.map(tag => tag.id)
        if (tagsLabel && tagsId) {
          this.allUserTableList.forEach(user => {
                if (tagsLabel.every(tag => user.tags.includes(tag))) {
                  matchingUsers.push(user.id)
                }
              }
          )
        }
      }
      if (this.addTags.length > 0) {
        this.editTag = 'add'
        tagsLabel = this.addTags.map(tag => tag.label)
        tagsId = this.addTags.map(tag => tag.id)
        if (tagsLabel && tagsId) {
          this.allUserTableList.forEach(user => {
                if (tagsLabel.every(tag => !user.tags.includes(tag))) {
                  matchingUsers.push(user.id)
                }
              }
          )
        }
      }
      if (matchingUsers.length > 0) {
        await this.closeDialog()
        await this.editUsersTags({userIds: matchingUsers, tagIds: tagsId, editTagType: this.editTag})
      }
      await this.fetchAllUsers()
    },
    resetTagDropdowns(){
      this.deleteTags = this.addTags = []
    },
    async closeDialog(){
      this.dialog = false
      this.addBtn = false
      this.removeBtn = false
      await this.resetTagDropdowns()
    }
  }
}
</script>

<style scoped>
.btn-end {
  justify-content: end;
  margin-top: auto;
}
</style>